import { FunctionComponent, useState } from 'react'
import { SearchRounded } from '@mui/icons-material'
import { InputAdornment, TextField } from '@black-bear-energy/rucksack'

export const SearchBar: FunctionComponent<SearchBarProps> = ({
  label,
  search,
  setSearch,
}) => {
  // Control the shrink state of the text field label.
  const [shrink, setShrink] = useState(false)

  return (
    <TextField
      fullWidth
      size="small"
      label={label}
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      onFocus={() => setShrink(true)}
      onBlur={(e) => setShrink(!!e.target.value)}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchRounded />
            </InputAdornment>
          ),
        },
        inputLabel: { shrink },
        htmlInput: { sx: { height: '24px', padding: '8px 0px' } },
      }}
      sx={{
        // Add left padding to the label when it's not shrunk to account for the start adornment.
        '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
          paddingLeft: 4,
        },
      }}
    />
  )
}

export interface SearchBarProps {
  label: string
  search: string
  setSearch: (search: string) => void
}
